import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import SweetAlertOld from 'hooks/SweetAlert';
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from 'moment';
import SwipeableViews from 'react-swipeable-views'; //paquete installado manual(npm i react-swipeable-views)
import stylesAlert from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';

// Components Article Detail
import LiquidationCommodity from 'components/Tvendo/Distribution/Operations/Liquidation/LiquidationCommodity.js';
import LiquidationDocuments from 'components/Tvendo/Distribution/Operations/Liquidation/LiquidationDocuments.js';
import LiquidationDocumentsCredit from 'components/Tvendo/Distribution/Operations/Liquidation/LiquidationDocumentsCredit.js';
/* import MissingLeftovers from 'components/Tvendo/Distribution/Operations/Liquidation/MissingLeftovers.js'; */

// Import Components
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { wsGetAll, wsFindBy } from 'services/WService';
import { useToasty, Toasty } from 'hooks/Toasty';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

// this is used for the special classes
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import {
  Tab,
  Tabs,
  AppBar,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@material-ui/core';

//@material-ui/icons
import { Assignment, Dashboard, Visibility } from '@material-ui/icons';

//Styles Regular Form
import stylesRegularForm from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle';
import { currency } from 'hooks/Pipe';

//Tabs
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import { listStatesHR } from 'contexts/statesHR';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  ...stylesAlert,
  ...stylesRegularForm,
  paper: {
    '& h5': {
      fontSize: '14px'
    }
  }
});

const columnsHR = [
  { Header: '#', accessor: 'id', excelEnabled: false },
  { Header: 'Zona', accessor: 'zone' },
  { Header: 'N° HR', accessor: 'hr' },
  { Header: 'Jefe de reparto', accessor: 'boss' },
  { Header: 'Placa vehículo', accessor: 'PlacaAuto' },
  { Header: 'Programación', accessor: 'programDate' },
  { Header: 'Despacho', accessor: 'entryDate' },
  { Header: 'Pedidos', accessor: 'orders' },
  { Header: 'Soles', accessor: 'Soles' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default function DetailProduct() {
  const classes = useStyles();
  const claseStyleTab = useStyleTabs();
  const themeTab = useTheme();
  const [alert, setAlert] = useState({ alert: '', message: '' });
  const [stateConfirm, setStateConfirm] = useState(null);
  const [notify, showNotify] = useToasty();
  const [alertMerca, setAlertMerca] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  const [sweetAlert, setSweetAlert] = useState();

  function confirmAlert(functionCallback, details = false) {
    setAlertMerca(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Está seguro cerrar diferencias?"
        onConfirm={() => {
          setAlertMerca(null);
          functionCallback();
        }}
        onCancel={() => {
          setAlertMerca(null);
        }}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        {details
          ? 'Al no ingresar devueltos o diferencias, en consecuencia se cierra el proceso'
          : ''}
      </SweetAlert>
    );
  }

  //#region reforma de clever
  const [filter, setFilter] = useState({
    start_date: moment().subtract(2, 'days').format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    base_zone_id: 0,
    state: 0
  });

  //#endregion

  //#region  smith code

  // Data de HR seleccionado
  const [selectedHR, setSelectedHR] = useState({ id: 0, state: '-1' });
  const [stateDifferences, setStateDifferences] = useState(null);

  // Estado actual y estado anterior de la HR
  const [newStateHR, setNewStateHR] = useState('0');
  const [stateHR, setStateHR] = useState('0');

  const [listHR, setHR] = useState([]);
  const [listHC, setListHC] = useState([]);
  /* const [listML, setListML] = useState([]); */
  const [listDoc, setDoc] = useState([]);
  const [listDocCredit, setDocCredit] = useState([]);
  const [dataOrigin, setDataOrigin] = useState([]);
  const [listZones, setZones] = useState([]);

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  function handleStateAndValueTab() {
    if (selectedHR.state != '-1') {
      setStateHR(listStatesHR.findIndex((e) => e.id == selectedHR.state) > 1 ? '0' : '1');
      setValue(
        parseInt(
          listStatesHR[listStatesHR.findIndex((e) => e.id == selectedHR.state)].id == 3 ||
            listStatesHR[listStatesHR.findIndex((e) => e.id == selectedHR.state)].id == 4
            ? '0'
            : '1'
        )
      );
    }
  }

  //#endregion

  //#region listados de apis
  // Listado de datos desde API
  async function listZone() {
    setDataLoading(true);
    let response = await wsGetAll('base/zone');
    setDataLoading(false);
    if (response.success) setZones(response.data);
  }

  async function getHR(filter) {
    let newFilter = filter;
    if (filter.state === 0) {
      newFilter.state = listStatesHR.map((item) => item.id);
    }
    if (filter.base_zone_id === 0) {
      delete newFilter.base_zone_id;
    }
    setDataLoading(true);
    let response = await wsFindBy('prog/sheet-distribution', newFilter);
    setDataLoading(false);
    if (response.success) setHR(response.data);
  }

  async function getHC(id) {
    setDataLoading(true);
    let response = await wsFindBy('prog/sheet-load', 'prog_sheet_distribution_id', id);
    setDataLoading(false);
    if (response.success) setListHC(response.data);
  }

  async function getDoc(id) {
    setDataLoading(true);
    let response = await wsFindBy('prog/sheet-document', 'prog_sheet_distribution_id', id);
    setDataLoading(false);
    if (response.success) setDoc(response.data);
  }
  async function getDocCredit(id) {
    setDataLoading(true);
    let response = await wsFindBy('prog/sheet-document', 'prog_sheet_distribution_id', id);
    setDataLoading(false);
    if (response.success) setDocCredit(response.data);
  }


  async function lisDocuments() {
    setDataLoading(true);

    let [responseLoad, responseDocument, responseDocumentCredit,responseDataOrigin] = await Promise.all([
        wsFindBy('prog/sheet-load', 'prog_sheet_distribution_id', selectedHR.id),
        wsFindBy('prog/sheet-document', 'prog_sheet_distribution_id', selectedHR.id),
        wsFindBy('prog/sheet-document', {
            prog_sheet_distribution_id: selectedHR.id,
            liq_status: 2,
            filter: JSON.stringify({ $or: [{ sap_excluded: 'Y' }, { GroupNum: { $gt: 0 } }] })
        }),
        wsFindBy(`prog/sheet-document/list-document/${selectedHR.id}`),
    ]);

    setDataLoading(false);
    
    // Verificar si al menos una de las condiciones del filtro se cumple.
    if (responseLoad.success && responseDocument.success && responseDocumentCredit.success && responseDataOrigin.success) {
      const documentData = responseDocumentCredit.data;
      const filteredData = documentData.filter(item => 
          ((item.sap_excluded === 'Y' || item.GroupNum > 0))
      );
      setListHC(responseLoad.data);
      setDoc(responseDocument.data);
      setDocCredit(filteredData);
      setDataOrigin(responseDataOrigin.data);
      const element = document.getElementById('hojaReparto');
      if (element) {
        element.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    } else {
        showNotify(`${responseLoad.message}\n${responseDocument.message}\n${responseDocumentCredit.message}\n${responseDataOrigin.message}`, 'error');
    }
}


  /* async function getMissingLeftovers(id) {
    let response = await wsFindBy('prog/difference', 'prog_sheet_distribution_id', id);
    if (response.success) setListML(response.data);
  } */

  //#endregion

  // Llama la función que devuelve la lista de HC, DOC, SOBRANTES Y FALTANTES al seleccionar un HR | seteo de estado de HR
  useEffect(() => {
    /* getHC(selectedHR.id);
    getDoc(selectedHR.id); */
    if (selectedHR.id) {
      lisDocuments();
    }
    /* getMissingLeftovers(selectedHR.id); */
    setStateDifferences(selectedHR.difference_closed);

    handleStateAndValueTab(); // Cambio de estado segun el estado actual.
  }, [selectedHR]);

  useEffect(() => {
    if (newStateHR != '' && newStateHR != '0') {
      setSelectedHR({ ...selectedHR, state: newStateHR });
    }
  }, [newStateHR]);

  useEffect(() => {
    listZone();
  }, []);

  useEffect(() => {
    getHR(filter);
  }, [filter]);

  return (
    <div>
      <Toasty action={notify} />
      <SweetAlertOld alert={alert} stateConfirm={setStateConfirm} />
      {alertMerca}
      {sweetAlert}
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>
            <b>Liquidación {dataLoading && <LoadingSpinner />}</b>
          </h4>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem sm={2} xl={2} xs={12}>
              <TextField
                label="Fecha Inicial"
                type="date"
                fullWidth
                name="start_date"
                size="small"
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                defaultValue={moment().subtract(2, 'days').format('YYYY-MM-DD')}
                onChange={(e) => {
                  setFilter({
                    ...filter,
                    start_date: e.target.value
                  });
                }}
              />
            </GridItem>
            <GridItem sm={2} xl={2} xs={12}>
              <TextField
                label="Fecha Final"
                type="date"
                fullWidth
                name="end_date"
                size="small"
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                defaultValue={moment().format('YYYY-MM-DD')}
                onChange={(e) => {
                  setFilter({
                    ...filter,
                    end_date: e.target.value
                  });
                }}
              />
            </GridItem>
            <GridItem sm={2} xl={2} xs={12}>
              <FormControl fullWidth size="small" margin="normal">
                <InputLabel>Zonas</InputLabel>
                <Select
                  MenuProps={{
                    className: classes.selectMenu
                  }}
                  defaultValue={0}
                  inputProps={{
                    name: 'base_zone_id'
                  }}
                  onChange={(e) => {
                    setFilter({
                      ...filter,
                      base_zone_id: e.target.value
                    });
                  }}
                >
                  <MenuItem value={0}>Todos</MenuItem>
                  {listZones.map((zone) => {
                    return (
                      <MenuItem key={zone.id} value={zone.id}>
                        {zone.description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem sm={2} xl={2} xs={12}>
              <FormControl fullWidth size="small" margin="normal">
                <InputLabel>Estado</InputLabel>
                <Select
                  MenuProps={{
                    className: classes.selectMenu
                  }}
                  defaultValue={0}
                  inputProps={{
                    name: 'state'
                  }}
                  onChange={(e) => {
                    setFilter({
                      ...filter,
                      state: e.target.value
                    });
                  }}
                >
                  <MenuItem value={0}>Todos</MenuItem>
                  {listStatesHR.map((bListHR) => {
                    return (
                      <MenuItem key={bListHR.id} value={bListHR.id}>
                        {bListHR.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>
          <ReactTable
            indexRow={[0, 1, 2, 4, 5, 6, 7, 8, 9, 10]}
            widthRow={[100, 120, 100, 150, 150, 150, 100, 100, 120, 0]}
            indexColumn={[7, 8]}
            defaultWidth={1400}
            alignColumn={['right', 'right']}
            columns={columnsHR}
            data={listHR.map((bHR, i) => {
              return {
                id: (
                  <div>
                    <AllowedGuard
                      permission={ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_SHOW}
                    >
                      <Button
                        justIcon
                        round
                        simple
                        color="primary"
                        className="like"
                        onClick={() => setSelectedHR(bHR)}
                      >
                        <Visibility />
                      </Button>
                    </AllowedGuard>
                    {i + 1}
                  </div>
                ),
                zone: bHR.base_zone_description,
                hr: bHR.id.toString(),
                boss: bHR.manager_name,
                PlacaAuto: bHR.prog_vehicle_code,
                programDate: bHR.scheduled_date,
                entryDate: bHR.dispatch_date,
                orders: '-',
                Soles: currency(bHR.amount),
                state:
                  listStatesHR.findIndex((obj) => obj.id == bHR.state) >= 0
                    ? listStatesHR[listStatesHR.findIndex((obj) => obj.id == bHR.state)].name
                    : '-',
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
      {selectedHR.id != '' ? (
        <Card style={{ marginTop: '50px' }} id="hojaReparto">
          <CardHeader icon>
            <CardIcon color="primary">
              <Dashboard />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Hojas de Reparto</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={4} sm={2} md={1} className={classes.paper}>
                <h6>N° HR</h6>
                <h5>{selectedHR.id || '-'}</h5>
              </GridItem>
              <GridItem xs={4} sm={2} md={1} className={classes.paper}>
                <h6>Fec. Contable</h6>
                <h5>
                  {!!selectedHR.liquidate_date
                    ? moment(selectedHR.liquidate_date).format('DD-MM-YYYY')
                    : '-'}
                </h5>
              </GridItem>
              <GridItem xs={4} sm={4} md={2} className={classes.paper}>
                <h6>Zona</h6>
                <h5>{selectedHR.base_zone_description || '-'}</h5>
              </GridItem>
              <GridItem xs={4} sm={4} md={4} className={classes.paper}>
                <h6>Jefe de reparto</h6>
                <h5>{selectedHR.manager_name || '-'}</h5>
              </GridItem>
              <GridItem xs={4} sm={4} md={2} className={classes.paper}>
                <h6>Programación</h6>
                <h5>{moment(selectedHR.scheduled_date).format('DD-MM-YYYY') || '-'}</h5>
              </GridItem>
              <GridItem xs={4} sm={4} md={2} className={classes.paper}>
                <h6>Estado</h6>
                <h5 key={selectedHR}>
                  {selectedHR.state != null
                    ? listStatesHR[listStatesHR.findIndex((obj) => obj.id == selectedHR.state)].name
                    : '-'}
                </h5>
              </GridItem>
            </GridContainer>
            <br />
            <div className={claseStyleTab.root}>
              <AppBar position="static" color="default">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="secondary"
                  textColor="secondary"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="tabs"
                >
                  <Tab label="Documentos" {...indexTab(0)} />
                  <Tab
                    label="Mercadería"
                    {...indexTab(1)}
                    disabled={stateHR == '1' ? true : false}
                  />
                  <Tab label="Documento de Credito" {...indexTab(2)} />
                </Tabs>
              </AppBar>

              <SwipeableViews
                className={claseStyleTab.fullWidth}
                axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
              >
                <AllowedGuard
                  permission={
                    ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_DOCUMENT_INDEX
                  }
                  component={
                    <h4>
                      <b>No tiene permiso</b>
                    </h4>
                  }
                >
                  <TabPanel value={value} index={0}>
                    <LiquidationDocuments
                      dataOrigin={dataOrigin}
                      dataDetail={listDoc}
                      dataHR={selectedHR}
                      setSelectedHR={setSelectedHR}
                      reload={() => getHR(filter)}
                      reloadListDoc={getDoc}
                      setAlert={setSweetAlert}
                      showNotify={showNotify}
                    />
                  </TabPanel>
                </AllowedGuard>
                <AllowedGuard
                  permission={
                    ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_COMMODITY_INDEX
                  }
                  component={
                    <h4>
                      <b>No tiene permiso</b>
                    </h4>
                  }
                >
                  <TabPanel value={value} index={1}>
                    <LiquidationCommodity
                      dataDetail={listHC}
                      dataHR={selectedHR}
                      newStateHR={setNewStateHR}
                      stateDifferences={stateDifferences}
                      setStateDifferences={setStateDifferences}
                      reload={() => getHR(filter)}
                      reloadHC={getHC}
                      confirmAlert={confirmAlert}
                      reloadDoc={getDoc}
                      setAlert={setAlert}
                      showNotify={showNotify}
                    />
                  </TabPanel>
                </AllowedGuard>
                <AllowedGuard
                  permission={
                    ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_COMMODITY_INDEX
                  }
                  component={
                    <h4>
                      <b>No tiene permiso</b>
                    </h4>
                  }
                >
                  <TabPanel value={value} index={2}>
                    <LiquidationDocumentsCredit
                      dataOrigin={dataOrigin}
                      dataDetail={listDocCredit}
                      dataHR={selectedHR}
                      data
                      setSelectedHR={setSelectedHR}
                      reload={() => getHR(filter)}
                      reloadListDoc={getDoc}
                      setAlert={setSweetAlert}
                      showNotify={showNotify}
                    />
                  </TabPanel>
                </AllowedGuard>
                {/* <AllowedGuard
                  permission={
                    ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_LEFT_OVERS_INDEX
                  }
                  component={
                    <h4>
                      <b>No tiene permiso</b>
                    </h4>
                  }
                >
                  <TabPanel value={value} index={2}>
                    <MissingLeftovers
                      dataDetail={listML}
                      dataHR={selectedHR}
                      stateDifferences={stateDifferences}
                      setStateDifferences={setStateDifferences}
                      setStateConfirm={setStateConfirm}
                      stateConfirm={stateConfirm}
                      reload={() => getHR(filter)}
                      reloadDoc={getDoc}
                      reloadHC={getHC}
                      reloadML={getMissingLeftovers}
                      setAlert={setAlert}
                      showNotify={showNotify}
                    />
                  </TabPanel>
                </AllowedGuard> */}
              </SwipeableViews>
            </div>
          </CardBody>
        </Card>
      ) : null}
    </div>
  );
}
